import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-promptcatalogpopup',
    templateUrl: './promptcatalogpopup.component.html',
    styleUrl: './promptcatalogpopup.component.scss',
    standalone: true,
    imports: [
      CommonModule,
      FormsModule,
    ]
})
export class PromptcatalogpopupComponent {
  @Input() organizationKey: string = ""
  @Input() prompts: string[] = []
  @Output() selectedPrompt: EventEmitter<string> = new EventEmitter<string>()
  @Output() onRemovePromptPopup: EventEmitter<boolean> = new EventEmitter<boolean>()

  constructor() {
    this.selectedPrompt = new EventEmitter<string>()
  }

  ngOnInit() {

  }

  removePromptPopup() {
    this.onRemovePromptPopup.emit(true)
  }

  selectPrompt(prompt: string) {
    this.selectedPrompt.emit(prompt)
  }

  closePopup() {
    this.selectedPrompt.emit("")
  }

}
